import React, { useEffect, useRef } from 'react';
interface CodeInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}
export function CodeInput({
  value,
  onChange,
  error
}: CodeInputProps) {
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);
  const handleChange = (index: number, digit: string) => {
    if (!/^\d*$/.test(digit)) return;
    const newValue = value.split('');
    newValue[index] = digit;
    const updatedValue = newValue.join('').slice(0, 6);
    onChange(updatedValue);
    if (digit && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && !value[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').replace(/\D/g, '');
    onChange(pastedData.slice(0, 6));
  };
  return <div className="space-y-2" data-id="element-54">
      <label className="block text-sm font-medium text-gray-700" data-id="element-55">
        Code de vérification
      </label>
      <div className="flex gap-2 justify-center" onPaste={handlePaste} data-id="element-56">
        {[0, 1, 2, 3, 4, 5].map(index => <input key={index} ref={el => inputRefs.current[index] = el} type="text" inputMode="numeric" maxLength={1} value={value[index] || ''} onChange={e => handleChange(index, e.target.value)} onKeyDown={e => handleKeyDown(index, e)} className={`w-12 h-14 text-center text-2xl font-bold border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-amber-500 transition-all ${error ? 'border-red-300 focus:border-red-500' : 'border-gray-200 focus:border-amber-500'}`} data-id="element-57" />)}
      </div>
      {error && <p className="text-sm text-red-600 text-center" data-id="element-58">{error}</p>}
      <p className="text-xs text-gray-500 text-center" data-id="element-59">
        Entrez le code à 6 chiffres envoyé par SMS
      </p>
    </div>;
}